<template>
  <section class="raw-json-section">
    <div class="raw-json-header">
      <h3>平台原始响应</h3>
      <Button
        type="text"
        icon="md-copy"
        :disabled="!value"
        @click="handleCopy"
      >
        复制JSON
      </Button>
    </div>
    <pre v-if="value">{{ formattedValue }}</pre>
    <div v-else class="raw-json-empty">平台未返回可展示的原始数据</div>
  </section>
</template>

<script>
import { copyText } from '@/libs/util'

export default {
  name: 'RawJsonPanel',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedValue() {
      if (!this.value) return ''
      try {
        return JSON.stringify(JSON.parse(this.value), null, 2)
      } catch (e) {
        return this.value
      }
    }
  },
  methods: {
    handleCopy() {
      if (!this.value) return
      copyText(this.formattedValue)
      this.$Message.success('原始JSON已复制')
    }
  }
}
</script>

<style scoped lang="less">
.raw-json-section {
  margin-top: 18px;
}

.raw-json-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    margin: 0;
    font-size: 15px;
  }
}

pre {
  max-height: 440px;
  margin: 8px 0 0;
  padding: 14px;
  overflow: auto;
  border: 1px solid #dcdee2;
  background: #20242b;
  color: #e8eaec;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  line-height: 1.65;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.raw-json-empty {
  margin-top: 8px;
  padding: 28px;
  border: 1px dashed #dcdee2;
  color: #999;
  text-align: center;
}
</style>
